<template>
  <div>
    <v-card class="quoteSideInfo">
      <v-toolbar color="grey darken-1" dark>
        <v-toolbar-title>
          <v-icon large>{{maidIcon}}</v-icon>
          Maid
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn flat slot="activator" @click="doSave()" :loading="quotation.saving">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
          <span>Save Quotation/Proposal</span>
        </v-tooltip>
        <v-tooltip top>
          <v-menu bottom left slot="activator">
            <v-btn slot="activator" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="promptNTU = true">
                <v-list-tile-title>Not Taken Up</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="promptVoid = true">
                <v-list-tile-title>Void</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <span>More Options</span>
        </v-tooltip>
      </v-toolbar>
      <template v-if="!value">
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs4>
                <v-subheader class="queryLabel">Quotation No.</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span class="title">{{commonForm.proposalNo}}</span>
              </v-flex>
              <template v-if="commonInfo.premium.premiumPayable">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Premium Payable</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span class="title">{{currPrefix}}{{formatDisplayNumber(commonInfo.premium.premiumPayable)}}</span>
                </v-flex>
              </template>
              <v-flex xs4>
                <v-subheader class="queryLabel">Current Status</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{currentStatusLabel}}</span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">Intermediary</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{intermediary}}</span>
              </v-flex>
              <template v-if="commonForm.product">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Product</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{product}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.scheme">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Scheme</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{scheme}}</span>
                </v-flex>
              </template>
              <template v-if="maidForm.planNo && plan !== ''">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Plan</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{plan}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.duration">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Duration</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{duration}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.startDate">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Acceptance Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{formatDisplayDateTime2(commonForm.acceptDate)}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.startDate">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Start Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{formatDate(commonForm.startDate)}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.endDate">
                <v-flex xs4>
                  <v-subheader class="queryLabel">End Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{formatDate(commonForm.endDate)}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.campaign">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Campaign</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{campaign}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.promotion">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Promotion</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{promotion}}</span>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card-text>
      </template>
    </v-card>
    <confirm v-model="promptNTU" @ok="doNTU">
      Confirm that you want to change the status of this Quotation to
      <b>Not Taken Up</b>?
    </confirm>
    <confirm v-model="promptVoid" @ok="doVoid">
      Confirm that you want to change the status of this Quotation to
      <b>Void</b>?
    </confirm>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { extractLabel } from '@/utils/extract'
import { formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { quoteStatus, appIcon } from '@/const/underwriting'

export default {
  data() {
    return {
      promptNTU: false,
      promptVoid: false
    }
  },
  computed: {
    quotation() {
      return this.$store.state.agency.quotation
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    currentStatusLabel() {
      if (quoteStatus[this.quotation.commonInfo.statusCode]) {
        return quoteStatus[this.quotation.commonInfo.statusCode]
      } else {
        return 'Unknown Status'
      }
    },
    maidForm() {
      return this.quotation.maidForm
    },
    commonForm() {
      return this.quotation.commonForm
    },
    commonInfo() {
      return this.quotation.commonInfo
    },
    maidParam() {
      return this.quotation.maidParam
    },
    intermediary() {
      return extractLabel(this.$store.state.agency.quotationSettings.intermediaries, this.quotation.commonForm.intermediary)
    },
    product() {
      return extractLabel(this.maidParam.product, this.commonForm.product)
    },
    scheme() {
      return extractLabel(this.maidParam.scheme, this.commonForm.scheme)
    },
    duration() {
      return extractLabel(this.maidParam.duration, this.commonForm.duration)
    },
    campaign() {
      return extractLabel(this.maidParam.campaign, this.commonForm.campaign)
    },
    promotion() {
      return extractLabel(this.maidParam.promotion, this.commonForm.promotion)
    },
    maidIcon() {
      return appIcon.MAID
    },
    plan() {
      if (this.maidParam.plans.plans !== undefined && this.maidParam.plans.plans !== null && this.maidForm.planNo !== undefined && this.maidForm.planNo !== null) {
        let label = ''
        for (var i = 0; i < this.maidParam.plans.plans.length; i++) {
          const arr = this.maidParam.plans.plans[i]
          if (arr.planNo === this.maidForm.planNo) {
            label = arr.planDesc
            break
          }
        }
        return label
      } else {
        return ''
      }
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayDateTime2(date) {
      return formatDisplayDateTime2(date)
    },
    doSave() {
      // Emit saving event on global event bus
      // Each quote page should listen to this and do partial Submit and save
      this.$root.$emit('saveQuote')
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    doNTU() {
      this.$root.$emit('ntu')
    },
    async doVoid() {
      this.$root.$emit('void')
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@media (min-width: 1264px) {
  .quoteSideInfo {
    // Module specific override
    // min-height: 425px;
  }
}

.permitStatus {
  padding-left: 20px;
}
</style>
